{#if show}
  <Panel 
    p="nm"
    bg="surface"
    border={is}
    color="dark"
    flex={dismiss || icon ? true : null}
    items="start"
    rounded="nm"
    {...props}
    >

    {#if icon}
      <Icon
        size="3"
        color={is} 
        name={is}
      /> 
    {/if}

    <slot></slot>

    {#if dismiss}
      <IconButton 
        on:click={() => show = false}
        size="xl" w=2 h=2
        color="dark" 
        name="close"
        round
        pointer hover
        /> 
    {/if}
    
  </Panel>
{/if}

<script>
  import { Css, Panel } from 'svelte-stylo'
  import { Icon } from 'svelte-stylo'
  import IconButton from '../buttons/IconButton.svelte';

  export let
    show = true,
    icon = null,
    is = 'info',
    dismiss = false;
    
  let 
    vw = 0,
    props = {};

  $: { if ($$props) 
    props = $$props;
  }
</script>
